import apiClient from './apiClient';

export const getMyData = () =>
  apiClient.get('/users/myself/').then(res => res.data);

export const fetchContestAdmins = () =>
  apiClient.get('/users/', {
    params: { type: 'contest_admin' },
  }).then(res => res.data);
